import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-cancelar-envio-email',
  templateUrl: './cancelar-envio-email.component.html',
  styleUrls: ['../../juridico.component.css']
})
export class CancelarEnvioEmailComponent implements OnInit {
  tipo = "gestao-vaga";
  frase = "";

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router, private meta: Meta) {
    this.route.params.subscribe(res => {
        this.tipo = res.tipo;
    });

    if (this.tipo == "gestao-vaga") {
        this.frase = "novas vagas como analista";

    } else if (this.tipo = "indicacoes-vaga"){
        this.frase = "novas indicações de vagas";

    } else {
        this.frase = "novas mensagens"
    }

    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Cancelar envio de e-mail de ' + this.frase
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Gerencie todo o seu processo de recrutamento e seleção em uma única plataforma. Reachr, a solução prática e inteligente de recrutamento digital.'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'vagas de emprego, oportunidade de trabalho, agencia de emprego, vagas, emprego, vaga de emprego, trabalhe conosco comunidade de emprego,'
    // });
  }

  ngOnInit(): void {
    setTimeout(() => {
        window.location.href = 'https://www.reachr.com.br/';
    }, 5000);
  }
}
